import { render } from "./ToastNotifications.vue?vue&type=template&id=98d99e8c"
import script from "./ToastNotifications.vue?vue&type=script&lang=js"
export * from "./ToastNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__